<template>
  <div class="container en025">
    <NoticeBox class="-success _mb-sm-40 _mb-md-60 _mt-sm-15 _mt-md-60">
      <NoticeHeader>
        <h1 class="heading">
          会員さま専用サイトへログインのうえご利用ください。
        </h1>
      </NoticeHeader>
    </NoticeBox>

    <BtngroupSingle class="_mb-sm-40">
      <BtnMain class="-main" router-name="ce001">
        会員さま専用サイトトップへ
      </BtnMain>
    </BtngroupSingle>

    <BtngroupSingle class="-margin-lg">
      <BtnMain class="-normal -lg" router-name="sv001">
        au PAY スマートローントップへ
      </BtnMain>
    </BtngroupSingle>
  </div>
  <!-- container -->
</template>

<script>
import { removeUserSessionCookie } from "@/utils/Auth";
import { setMeta } from "@/utils/Meta";
import NoticeBox from "@/components/box/NoticeBox";
import NoticeHeader from "@/components/box/NoticeHeader";
import BtnMain from "@/components/button/BtnMain";
import BtngroupSingle from "@/components/button/BtngroupSingle";

export default {
  name: "En025",
  components: {
    BtngroupSingle,
    BtnMain,
    NoticeHeader,
    NoticeBox,
  },
  setup() {
    setMeta({
      title: "au PAY スマートローン",
      titleTemplate: null,
      description:
        "au PAY スマートローンはau IDをお持ちのお客様のための便利なカードレスローンサービスです。お申込みは、スマートフォン・パソコンでかんたんWEB完結！24時間お申込み可能。最短30分で審査結果をご連絡します。",
      keywords:
        "au PAY スマートローン,au,カードレスローン,スマートフォン,au PAY 残高,セブン銀行スマホATM,借入,返済,手続き,入会",
    });
  },
  mounted() {
    removeUserSessionCookie();
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/stylesheets/styles";
</style>
